module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/iphoneBg-049aa2a3b76dbb8bad664dd15f2d66be.png";